export const environment = {
  production: true,
  buildId: '3341195964921721',
  configFile: 'config.json',
};
